module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-19 at 12.53.28 PM(1).8ab4c378.jpg";